import { render, staticRenderFns } from "./ClientZoneUsersTableItem.vue?vue&type=template&id=a5017210&"
import script from "./ClientZoneUsersTableItem.vue?vue&type=script&lang=ts&"
export * from "./ClientZoneUsersTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports